// extracted by mini-css-extract-plugin
export default {"container":"z7-z","list":"A7-z"};